import React from 'react';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import { ZitoneoViewMode } from '../../../types/zitoneoServicesTypes';
import useTranslate from '../../../../../customHooks/useTranslate';
import ModeSelector from './ModeSelector';

const ServicesViewModeSelector = () => {
    const translate = useTranslate();

    const { changeViewMode, viewMode } = useZitoneoServices();
    return (
        <ModeSelector
            selectedValue={viewMode}
            onChange={changeViewMode}
            options={[
                {
                    value: ZitoneoViewMode.EDITOR,
                    iconName: 'Edit',
                    label: translate('editor'),
                },
                {
                    value: ZitoneoViewMode.PREVIEW,
                    iconName: 'Language',
                    label: translate('preview'),
                },
            ]}
        />
    );
};

export default ServicesViewModeSelector;
